import { generateProgressNote } from '@/utils/printExport';

/** Print/PDF export via browser print dialog (PSD §8.2 / TODO Task 2.20). */
export function ExportButton(): JSX.Element {
  const handleExport = (): void => {
    const note = generateProgressNote();
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Amino PK Note</title>
        <style>
          body { font-family: monospace; padding: 40px; max-width: 700px; margin: 0 auto; }
          pre { white-space: pre-wrap; word-wrap: break-word; }
          @media print { body { padding: 20px; } }
        </style>
      </head>
      <body>
        <pre>${note.replace(/</g, '&lt;')}</pre>
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 250);
  };

  return (
    <button className="btn" onClick={handleExport} data-testid="export-pdf">
      Export / Print PDF
    </button>
  );
}
